import PropTypes from 'prop-types';

import BaseMessage from './BaseMessage';

import styles from './info-message.scss';
import footerStyles from './answer-message-footer.scss';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import KnowledgeGraphButton from 'components/buttons/KnowledgeGraphButton';
import Icon from '../icons/Icon';
import ChatMessageMarkdownHtml from './ChatMessageMarkdownHtml/ChatMessageMarkdownHtml';

const customFooter = (
  <aside className={footerStyles.buttonsContainer}>
    <ul className={footerStyles.list}>
      <li className={footerStyles.item}>
        <KnowledgeGraphButton />
      </li>
    </ul>
  </aside>
);

const InfoMessage = ({
  message,
  hasKnowledgeGraphSupport,
  isWarningMessage,
  multiStepPosition,
  disableRetry,
  disableTrailer
}) => {
  const showKnowledgeGraphFooter = hasKnowledgeGraphSupport && message.suggestKnowledgeGraph;
  const messageClassName = showKnowledgeGraphFooter ? `${styles.wrapper} ${styles.withFooter}` : styles.wrapper;

  const contentContainer = (
    <div>
      <ChatMessageMarkdownHtml html={message.textAnswer} />
    </div>
  );

  const answer = (
    <div className={messageClassName}>
      {isWarningMessage ? (
        <Icon data-test="icon-warning" type="icon-warning" />
      ) : (
        message.isError && <ErrorRoundedIcon style={{ fontSize: '2em', color: 'var(--error-red)' }} />
      )}
      {isWarningMessage || message.isError ? <span className={styles.desc}>{contentContainer}</span> : contentContainer}
    </div>
  );

  return (
    <div data-test="veezooInfoMessage" key={message.id}>
      <BaseMessage
        key={message.id}
        messageId={message.id}
        showVeezooIcon={message.showVeezooIcon}
        content={answer}
        // enable retry for any messages that are associated with a question, but only once streaming has stopped
        //  (this allows re-trying system zero text answers or error messages originating from questions)
        questionId={message.questionId}
        enableRetry={!!message.questionId && !disableRetry}
        enableTrailer={!disableTrailer}
        customFooter={showKnowledgeGraphFooter ? customFooter : <></>}
        multiStepPosition={multiStepPosition}
        timestamp={message.timestamp}
      />
    </div>
  );
};

export default InfoMessage;

InfoMessage.propTypes = {
  message: PropTypes.object,
  hasKnowledgeGraphSupport: PropTypes.bool,
  isWarningMessage: PropTypes.bool,
  multiStepPosition: PropTypes.oneOf(['first', 'middle', 'last', 'single', null]),
  disableRetry: PropTypes.bool,
  disableTrailer: PropTypes.bool
};

InfoMessage.defaultProps = {
  disableTrailer: false,
  disableRetry: false
};
